import { render, staticRenderFns } from "./MessageBox.pug?vue&type=template&id=8ab2d046&scoped=true&lang=pug&"
import script from "./MessageBox.vue?vue&type=script&lang=js&"
export * from "./MessageBox.vue?vue&type=script&lang=js&"
import style0 from "./MessageBox.scss?vue&type=style&index=0&id=8ab2d046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab2d046",
  null
  
)

export default component.exports